import { features } from "@/mocks/faq";

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            Why Choose It
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Why Global Buyers Use the{" "}
            <span className="text-primary-600">ACBuy Spreadsheet</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-xl mx-auto">
            Thousands of international buyers trust this sourcing system for one simple reason — it works
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 md:p-7 hover:bg-background-200/30 transition-colors duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}